// extracted by mini-css-extract-plugin
export var m_zt = "zonaTransaccional-module--m_zt--3e16d";
export var m_ztopen = "zonaTransaccional-module--m_ztopen--c7d74";
export var zt__open = "zonaTransaccional-module--zt__open--c98e4";